import { SubHeader, SubHeaderActions } from '../../../components/SubHeader';
import { DebouncedSearchInput } from '../../../components/DebouncedSearchInput';
import { useEventHistoryFiltersContext } from '../contexts/EventHistoryFiltersContext';
import { FiltersMenu } from './FiltersMenu';

const displayContent = {
  labelFilters: 'Filters',
  pageTitle: 'Event history',
  searchPlaceholder: 'Search event history',
};
const PageActions = () => {
  const { search, setSearch } = useEventHistoryFiltersContext();

  return (
    <SubHeaderActions>
      <FiltersMenu />
      <DebouncedSearchInput
        id="event-history-search"
        placeholder={displayContent.searchPlaceholder}
        value={search}
        onChange={setSearch}
      />
    </SubHeaderActions>
  );
};

export const EventHistoryIndexHeader = () => (
  <SubHeader actions={<PageActions />}>{displayContent.pageTitle}</SubHeader>
);
